import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableBodyRoot } from './TableBody.styled';
// Component.
// -----------------------------------------------------------------------------
const TableBody = forwardRef(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableBodyRoot, { ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableBody.displayName = 'TableBody';
export default TableBody;
//# sourceMappingURL=TableBody.js.map